import React from "react";
import 'app/admin/whoisit/cards/table/search.css'
import {useTranslation} from "react-i18next";

const Search = ({ preGlobalFilteredRows, globalFilter, setGlobalFilter }) => {
  const { t } = useTranslation();

  return (
    <input
      className="AdminWhoisitCardsSearchInput"
      placeholder={t('admin.whoisit.cards.search', { count: preGlobalFilteredRows.length })}
      value={globalFilter || ''}
      onChange={e => {
        setGlobalFilter(e.target.value || undefined)
      }}
    />
  );
};

export default Search;
